export const CapitalizeFirstLetter = sentence => {
  if (!sentence) return '';
  const words = sentence.split(' ');

  const capitalizedWords = words.map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });

  return capitalizedWords.join(' ');
};
